/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */ import { css } from 'styled-components';
import { map } from '../../breakpoint';
export const width = ()=>css`
  ${({ width })=>map(width, (val)=>val !== undefined && css`
          width: ${val};
        `)};
`;
export const minWidth = ()=>css`
  ${({ minWidth })=>map(minWidth, (val)=>val !== undefined && css`
          min-width: ${val};
        `)};
`;
export const maxWidth = ()=>css`
  ${({ maxWidth })=>map(maxWidth, (val)=>val !== undefined && css`
          max-width: ${val};
        `)};
`;
export const height = ()=>css`
  ${({ height })=>map(height, (val)=>val !== undefined && css`
          height: ${val};
        `)};
`;
export const minHeight = ()=>css`
  ${({ minHeight })=>map(minHeight, (val)=>val !== undefined && css`
          min-height: ${val};
        `)};
`;
export const maxHeight = ()=>css`
  ${({ maxHeight })=>map(maxHeight, (val)=>val !== undefined && css`
          max-height: ${val};
        `)};
`;

//# sourceMappingURL=dimensions.js.map